// import React from "react";

// const FilterSidebar = () => {
//   return (
//     <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12 filtercolumn">
//       <div className="filterpanel">

//         {/* Suggested For You */}
//         <div className="filterpanelbody">
//           <h3>Suggested For You</h3>
//           <div className="filtercheckbody">
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="earlyBird" />
//               <label className="form-check-label" htmlFor="earlyBird">
//                 Early Bird Deals
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="freeCancel" />
//               <label className="form-check-label" htmlFor="freeCancel">
//                 Free Cancellation
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="breakfastOnly" />
//               <label className="form-check-label" htmlFor="breakfastOnly">
//                 Breakfast Included
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="breakfastLunch" />
//               <label className="form-check-label" htmlFor="breakfastLunch">
//                 Breakfast + Lunch/Dinner Included
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="allMeals" />
//               <label className="form-check-label" htmlFor="allMeals">
//                 All Meals Included
//               </label>
//             </div>
//           </div>
//         </div>

//         {/* Price per night */}
//         <div className="filterpanelbody">
//           <h3>Price per night</h3>
//           <div className="filtercheckbody">
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="earlyBird2" />
//               <label className="form-check-label" htmlFor="earlyBird2">
//                 Early Bird Deals
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="price1" />
//               <label className="form-check-label" htmlFor="price1">
//                 ₹ 1500 - ₹ 2500
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="price2" />
//               <label className="form-check-label" htmlFor="price2">
//                 ₹ 2500 - ₹ 6000
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="price3" />
//               <label className="form-check-label" htmlFor="price3">
//                 ₹ 6000 - ₹ 9500
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="price4" />
//               <label className="form-check-label" htmlFor="price4">
//                 ₹ 9500 - ₹ 13000
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="price5" />
//               <label className="form-check-label" htmlFor="price5">
//                 ₹ 13000 - ₹ 15000
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="price6" />
//               <label className="form-check-label" htmlFor="price6">
//                 ₹ 15000 - ₹ 30000
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="price7" />
//               <label className="form-check-label" htmlFor="price7">
//                 ₹ 30000+
//               </label>
//             </div>
//           </div>
//         </div>

//         {/* User Rating */}
//         <div className="filterpanelbody">
//           <h3>User Rating</h3>
//           <div className="filtercheckbody">
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="ratingExcellent" />
//               <label className="form-check-label" htmlFor="ratingExcellent">
//                 Excellent: 4.2+
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="ratingVeryGood" />
//               <label className="form-check-label" htmlFor="ratingVeryGood">
//                 Very Good: 3.5+
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="ratingGood" />
//               <label className="form-check-label" htmlFor="ratingGood">
//                 Good: 3+
//               </label>
//             </div>
//           </div>
//         </div>

//         {/* House Rules */}
//         <div className="filterpanelbody">
//           <h3>House Rules</h3>
//           <div className="filtercheckbody">
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="smokingAllowed" />
//               <label className="form-check-label" htmlFor="smokingAllowed">
//                 Smoking Allowed
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="unmarriedCouplesAllowed" />
//               <label className="form-check-label" htmlFor="unmarriedCouplesAllowed">
//                 Unmarried Couples Allowed
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="petsAllowed" />
//               <label className="form-check-label" htmlFor="petsAllowed">
//                 Pets Allowed
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="alcoholAllowed" />
//               <label className="form-check-label" htmlFor="alcoholAllowed">
//                 Alcohol Allowed
//               </label>
//             </div>
//           </div>
//         </div>

//         {/* Room Views */}
//         <div className="filterpanelbody">
//           <h3>Room Views</h3>
//           <div className="filtercheckbody">
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="valleyView" />
//               <label className="form-check-label" htmlFor="valleyView">
//                 Valley View
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="forestView" />
//               <label className="form-check-label" htmlFor="forestView">
//                 Forest View
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="gardenView" />
//               <label className="form-check-label" htmlFor="gardenView">
//                 Garden View
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="mountainView" />
//               <label className="form-check-label" htmlFor="mountainView">
//                 Mountain View
//               </label>
//             </div>
//           </div>
//         </div>

//         {/* Top locations */}
//         <div className="filterpanelbody">
//           <h3>Top locations</h3>
//           <div className="filtercheckbody">
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="mallRoad" />
//               <label className="form-check-label" htmlFor="mallRoad">
//                 Mall Road
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="chowrasta" />
//               <label className="form-check-label" htmlFor="chowrasta">
//                 Chowrasta
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="darjeelingStation" />
//               <label className="form-check-label" htmlFor="darjeelingStation">
//                 Darjeeling Railway Station
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="chaukBazaar" />
//               <label className="form-check-label" htmlFor="chaukBazaar">
//                 Chauk Bazaar
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="tinchuleyVillage" />
//               <label className="form-check-label" htmlFor="tinchuleyVillage">
//                 Tinchuley Village
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="lepchaJagat" />
//               <label className="form-check-label" htmlFor="lepchaJagat">
//                 Lepcha Jagat
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="ghoom" />
//               <label className="form-check-label" htmlFor="ghoom">
//                 Ghoom
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="gandhiRoad" />
//               <label className="form-check-label" htmlFor="gandhiRoad">
//                 Gandhi Road
//               </label>
//             </div>
//           </div>
//         </div>

//         {/* Amenities */}
//         <div className="filterpanelbody">
//           <h3>Amenities</h3>
//           <div className="filtercheckbody">
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="wifi" />
//               <label className="form-check-label" htmlFor="wifi">
//                 Wi-Fi
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="swimmingPool" />
//               <label className="form-check-label" htmlFor="swimmingPool">
//                 Swimming Pool
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="roomService" />
//               <label className="form-check-label" htmlFor="roomService">
//                 Room Service
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="bonfire" />
//               <label className="form-check-label" htmlFor="bonfire">
//                 Bonfire
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="kitchenette" />
//               <label className="form-check-label" htmlFor="kitchenette">
//                 Kitchenette
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="barbeque" />
//               <label className="form-check-label" htmlFor="barbeque">
//                 Barbeque
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="elevator" />
//               <label className="form-check-label" htmlFor="elevator">
//                 Elevator/Lift
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="restaurant" />
//               <label className="form-check-label" htmlFor="restaurant">
//                 Restaurant
//               </label>
//             </div>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default FilterSidebar;

// import React, { useEffect, useState } from "react";
// import axios from "axios";

// const FilterSidebar = () => {
//   const [amenities, setAmenities] = useState([]);
//   const [locations, setLocations] = useState([]);

//   useEffect(() => {
//     const fetchFilters = async () => {
//       try {
//         const [amenityRes, locationRes] = await Promise.all([
//           axios.get("https://demo.wgi-it.com:3002/api/v1/stays/amenities"),
//           axios.get("https://demo.wgi-it.com:3002/api/v1/stays/locations"),
//         ]);
//        setAmenities(amenityRes.data?.data || []);   //. use .data.data
//         setLocations(locationRes.data?.data || []);  //. use .data.data
//       } catch (err) {
//         console.error("Error fetching filter data:", err);
//       }
//     };
//     fetchFilters();
//   }, []);
// console.log("Locations:", locations);
//   return (
//     <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12 filtercolumn">
//       <div className="filterpanel">

//         {/* Suggested For You */}
//         <div className="filterpanelbody">
//           <h3>Suggested For You</h3>
//           <div className="filtercheckbody">
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="earlyBird" />
//               <label className="form-check-label" htmlFor="earlyBird">
//                 Early Bird Deals
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="freeCancel" />
//               <label className="form-check-label" htmlFor="freeCancel">
//                 Free Cancellation
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="breakfastOnly" />
//               <label className="form-check-label" htmlFor="breakfastOnly">
//                 Breakfast Included
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="breakfastLunch" />
//               <label className="form-check-label" htmlFor="breakfastLunch">
//                 Breakfast + Lunch/Dinner Included
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="allMeals" />
//               <label className="form-check-label" htmlFor="allMeals">
//                 All Meals Included
//               </label>
//             </div>
//           </div>
//         </div>

//         {/* Price per night */}
//         <div className="filterpanelbody">
//           <h3>Price per night</h3>
//           <div className="filtercheckbody">
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="earlyBird2" />
//               <label className="form-check-label" htmlFor="earlyBird2">
//                 Early Bird Deals
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="price1" />
//               <label className="form-check-label" htmlFor="price1">
//                 ₹ 1500 - ₹ 2500
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="price2" />
//               <label className="form-check-label" htmlFor="price2">
//                 ₹ 2500 - ₹ 6000
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="price3" />
//               <label className="form-check-label" htmlFor="price3">
//                 ₹ 6000 - ₹ 9500
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="price4" />
//               <label className="form-check-label" htmlFor="price4">
//                 ₹ 9500 - ₹ 13000
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="price5" />
//               <label className="form-check-label" htmlFor="price5">
//                 ₹ 13000 - ₹ 15000
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="price6" />
//               <label className="form-check-label" htmlFor="price6">
//                 ₹ 15000 - ₹ 30000
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="price7" />
//               <label className="form-check-label" htmlFor="price7">
//                 ₹ 30000+
//               </label>
//             </div>
//           </div>
//         </div>

//         {/* User Rating */}
//         <div className="filterpanelbody">
//           <h3>User Rating</h3>
//           <div className="filtercheckbody">
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="ratingExcellent" />
//               <label className="form-check-label" htmlFor="ratingExcellent">
//                 Excellent: 4.2+
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="ratingVeryGood" />
//               <label className="form-check-label" htmlFor="ratingVeryGood">
//                 Very Good: 3.5+
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="ratingGood" />
//               <label className="form-check-label" htmlFor="ratingGood">
//                 Good: 3+
//               </label>
//             </div>
//           </div>
//         </div>

//         {/* House Rules */}
//         <div className="filterpanelbody">
//           <h3>House Rules</h3>
//           <div className="filtercheckbody">
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="smokingAllowed" />
//               <label className="form-check-label" htmlFor="smokingAllowed">
//                 Smoking Allowed
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="unmarriedCouplesAllowed" />
//               <label className="form-check-label" htmlFor="unmarriedCouplesAllowed">
//                 Unmarried Couples Allowed
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="petsAllowed" />
//               <label className="form-check-label" htmlFor="petsAllowed">
//                 Pets Allowed
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="alcoholAllowed" />
//               <label className="form-check-label" htmlFor="alcoholAllowed">
//                 Alcohol Allowed
//               </label>
//             </div>
//           </div>
//         </div>

//         {/* Room Views */}
//         <div className="filterpanelbody">
//           <h3>Room Views</h3>
//           <div className="filtercheckbody">
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="valleyView" />
//               <label className="form-check-label" htmlFor="valleyView">
//                 Valley View
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="forestView" />
//               <label className="form-check-label" htmlFor="forestView">
//                 Forest View
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="gardenView" />
//               <label className="form-check-label" htmlFor="gardenView">
//                 Garden View
//               </label>
//             </div>
//             <div className="form-check">
//               <input className="form-check-input" type="checkbox" id="mountainView" />
//               <label className="form-check-label" htmlFor="mountainView">
//                 Mountain View
//               </label>
//             </div>
//           </div>
//         </div>

//         {/* Top locations */}
//         <div className="filterpanelbody">
//           <h3>Top locations</h3>
//           <div className="filtercheckbody">
//             {locations.length > 0 ? (
//               locations.map((loc) => (
//                 <div className="form-check" key={loc.id}>
//                   <input
//                     className="form-check-input"
//                     type="checkbox"
//                     id={`location-${loc.id}`}
//                   />
//                   <label
//                     className="form-check-label"
//                     htmlFor={`location-${loc.id}`}
//                   >
//                     {loc.location_name}
//                   </label>
//                 </div>
//               ))
//             ) : (
//               <p>Loading locations...</p>
//             )}
//           </div>
//         </div>

//         {/* Amenities */}
//         <div className="filterpanelbody">
//           <h3>Amenities</h3>
//           <div className="filtercheckbody">
//             {amenities.length > 0 ? (
//               amenities.map((amenity) => (
//                 <div className="form-check" key={amenity.id}>
//                   <input
//                     className="form-check-input"
//                     type="checkbox"
//                     id={`amenity-${amenity.id}`}
//                   />
//                   <label
//                     className="form-check-label"
//                     htmlFor={`amenity-${amenity.id}`}
//                   >
//                     {amenity.name}
//                   </label>
//                 </div>
//               ))
//             ) : (
//               <p>Loading amenities...</p>
//             )}
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default FilterSidebar;
import React, { useEffect, useState } from "react";
import axios from "axios";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import API_BASE_URL from "../../src/config";

// Client-side only — narrows whatever the main search already returned,
// never re-queries the backend. Deliberately kept separate from onFilter
// (which does trigger a fresh search) so this can never affect core search.
const PROPERTY_TYPES = [
  { value: "heritage", label: "Heritage Homestays" },
  { value: "eco_farmstay", label: "Eco-Stays/Farmstays" },
  { value: "tea_garden_estate", label: "Tea Garden Estates" },
  { value: "wilderness_ecostay", label: "Wilderness Ecostay" },
  { value: "jungle_camp", label: "Jungle Camp" },
  { value: "riverside", label: "Riverside" },
];

const FilterSidebar = ({ onFilter, priceRange, onPropertyTypeFilter, initialPromoCodes }) => {
  console.log(priceRange);

  const [amenities, setAmenities] = useState([]);
  const [locations, setLocations] = useState([]);
  const [promoCodes, setPromoCodes] = useState([]);
  const [isPriceSelected, setIsPriceSelected] = useState(false);
  const [selectedPropertyTypes, setSelectedPropertyTypes] = useState([]);

  const [selectedFilters, setSelectedFilters] = useState({
    locations: [],
    amenities: [],
    promo_codes: [],
  });

  const handlePropertyTypeChange = (value) => {
    setSelectedPropertyTypes((prev) => {
      const updated = prev.includes(value)
        ? prev.filter((v) => v !== value)
        : [...prev, value];
      onPropertyTypeFilter?.(updated);
      return updated;
    });
  };



  useEffect(() => {
    // ❗ whenever API sends new price range → reset user selection
    setSelectedFilters((prev) => ({
      ...prev,
      min_price: undefined,
      max_price: undefined,
    }));

    setIsPriceSelected(false);
  }, [priceRange]);

  // Pre-check promo code(s) carried over from the homepage Offers "Book Now"
  // button (or any other entry point passing promo_codes via navigation state).
  useEffect(() => {
    setSelectedFilters((prev) => ({
      ...prev,
      promo_codes: initialPromoCodes && initialPromoCodes.length > 0 ? initialPromoCodes : [],
    }));
  }, [initialPromoCodes]);
  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const [amenityRes, locationRes, promoRes] = await Promise.all([

          axios.get(`${API_BASE_URL}stays/amenities`),
          axios.get(`${API_BASE_URL}stays/locations`),
          axios.get(`${API_BASE_URL}stays/promo-codes`),
        ]);
        setAmenities(amenityRes.data?.data || []);
        setLocations(locationRes.data?.data || []);
        setPromoCodes(promoRes.data?.data || []);
      } catch (err) {
        console.error("Error fetching filter data:", err);
      }
    };
    fetchFilters();
  }, []);

  // Handle toggle for location
  // const handleLocationChange = (id) => {
  //   setSelectedFilters((prev) => {
  //     const newLocations = prev.locations.includes(id)
  //       ? prev.locations.filter((loc) => loc !== id)
  //       : [...prev.locations, id];
  //     const updated = { ...prev, locations: newLocations };
  //     onFilterChange?.(updated); // send to parent
  //     return updated;
  //   });
  // };
  // const handleLocationChange = (locationId) => {
  //   const updated = {
  //     ...selectedFilters,
  //     destination_id: locationId, // single destination id
  //   };
  //   setSelectedFilters(updated);
  //   onFilter?.(updated);
  // };

  const handleLocationChange = (locationId) => {
    const updated = {
      ...selectedFilters,
      destination_id: locationId, // single destination id
    };
    setSelectedFilters(updated);
    onFilter?.(updated);
  };

  // Handle toggle for amenities
  // const handleAmenityChange = (id) => {
  //   setSelectedFilters((prev) => {
  //     const newAmenities = prev.amenities.includes(id)
  //       ? prev.amenities.filter((a) => a !== id)
  //       : [...prev.amenities, id];
  //     const updated = { ...prev, amenities: newAmenities };
  //     onFilter?.(updated); // send to parent
  //     return updated;
  //   });
  // };

  const handleAmenityChange = (id) => {
    setIsPriceSelected(false); // ❗ reset price selection

    setSelectedFilters((prev) => {
      let newAmenities = prev.amenities.includes(id)
        ? prev.amenities.filter((a) => a !== id)
        : [...prev.amenities, id];

      const updated = { ...prev, amenities: newAmenities };

      delete updated.min_price;
      delete updated.max_price;

      onFilter?.(updated, false);
      return updated;
    });
  };

  const handlePromoCodeChange = (code) => {
    setSelectedFilters((prev) => {
      const newPromoCodes = prev.promo_codes.includes(code)
        ? prev.promo_codes.filter((c) => c !== code)
        : [...prev.promo_codes, code];
      const updated = { ...prev, promo_codes: newPromoCodes };
      onFilter?.(updated, false);
      return updated;
    });
  };

  const priceRanges = [
    { min_price: 500, max_price: 1500 },
    { min_price: 1500, max_price: 2500 },
    { min_price: 2500, max_price: 4000 },
    { min_price: 4000, max_price: 6000 },
    { min_price: 6000, max_price: 9000 },
    { min_price: 9000, max_price: 12000 },
    { min_price: 12000, max_price: 20000 },
    { min_price: 20000 } // open-ended (20000+)
  ];

  // helper to compare ranges
  const isSameRange = (r) => {
    const p = selectedFilters?.price;
    if (!p && !r) return true;
    if (!p || !r) return false;
    return p.min_price === r.min_price && ((p.max_price ?? null) === (r.max_price ?? null));
  };

  // handler for radio change
  const handlePriceChange = (range) => {
    setIsPriceSelected(true); //. user touched price

    setSelectedFilters((prev) => {
      const updated = {
        ...prev,
        min_price: range ? range.min : null,
        max_price: range ? range.max : null,
      };
      onFilter?.(updated, true); //. pass flag to parent
      return updated;
    });
  };

  const sliderMin = isPriceSelected
    ? selectedFilters?.min_price
    : priceRange?.[0];

  const sliderMax = isPriceSelected
    ? selectedFilters?.max_price
    : priceRange?.[1];

  return (
    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12 filtercolumn">
      <div className="filterpanel">

        {/* Suggested For You */}
        {/* <div className="filterpanelbody">
          <h3>Suggested For You</h3>
          <div className="filtercheckbody">
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="earlyBird" />
              <label className="form-check-label" htmlFor="earlyBird">
                Early Bird Deals
              </label>
            </div>
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="freeCancel" />
              <label className="form-check-label" htmlFor="freeCancel">
                Free Cancellation
              </label>
            </div>
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="breakfastOnly" />
              <label className="form-check-label" htmlFor="breakfastOnly">
                Breakfast Included
              </label>
            </div>
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="breakfastLunch" />
              <label className="form-check-label" htmlFor="breakfastLunch">
                Breakfast + Lunch/Dinner Included
              </label>
            </div>
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="allMeals" />
              <label className="form-check-label" htmlFor="allMeals">
                All Meals Included
              </label>
            </div>
          </div>
        </div> */}

        {/* Price per night */}
        {/* <div className="filterpanelbody">
          <h3>Price per night</h3>
          <div className="filtercheckbody">


            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="price1" />
              <label className="form-check-label" htmlFor="price1">
                ₹ 500 - ₹ 100
              </label>
            </div>
 
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="price1" />
              <label className="form-check-label" htmlFor="price1">
                ₹ 1500 - ₹ 2500
              </label>
            </div>
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="price2" />
              <label className="form-check-label" htmlFor="price2">
                ₹ 2500 - ₹ 6000
              </label>
            </div>
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="price3" />
              <label className="form-check-label" htmlFor="price3">
                ₹ 6000 - ₹ 9500
              </label>
            </div>
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="price4" />
              <label className="form-check-label" htmlFor="price4">
                ₹ 9500 - ₹ 13000
              </label>
            </div>
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="price5" />
              <label className="form-check-label" htmlFor="price5">
                ₹ 13000 - ₹ 15000
              </label>
            </div>
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="price6" />
              <label className="form-check-label" htmlFor="price6">
                ₹ 15000 - ₹ 30000
              </label>
            </div>
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="price7" />
              <label className="form-check-label" htmlFor="price7">
                ₹ 30000+
              </label>
            </div>
          </div>
        </div> */}

        {/* <div className="filterpanelbody">
  <h3>Price per night</h3>
  <div className="filtercheckbody">

  
    <div className="form-check">
      <input
        className="form-check-input"
        type="radio"
        name="priceRange"
        id="allPrices"
        value="all"
        checked={!selectedFilters?.min_price && !selectedFilters?.max_price}
        onChange={() => handlePriceChange(null)}
      />
      <label className="form-check-label" htmlFor="allPrices">
        All Prices
      </label>
    </div>

    {[
      { label: "₹500 - ₹1500", min: 500, max: 1500 },
      { label: "₹1500 - ₹2500", min: 1500, max: 2500 },
      { label: "₹2500 - ₹3500", min: 2500, max: 3500 },
      { label: "₹3500 - ₹5000", min: 3500, max: 5000 },
      { label: "₹5000+", min: 5000, max: null },
    ].map((range, idx) => (
      <div className="form-check" key={idx}>
        <input
          className="form-check-input"
          type="radio"
          name="priceRange"
          id={`price${idx}`}
          value={`${range.min}-${range.max ?? "plus"}`}
          checked={
            selectedFilters?.min_price === range.min &&
            selectedFilters?.max_price === range.max
          }
          onChange={() => handlePriceChange(range)}
        />
        <label className="form-check-label" htmlFor={`price${idx}`}>
          {range.max ? `₹ ${range.min} - ₹ ${range.max}` : `₹ ${range.min}+`}
        </label>
      </div>
    ))}
  </div>
</div> */}
        {priceRange?.[0] !== priceRange?.[1] && (
          <div className="filterpanelbody">
            <h3>Price per night</h3>
            <div className="filtercheckbody">
              <Slider
                range
                min={priceRange?.[0] || 0}
                max={priceRange?.[1] || 10000}
                step={100}
                value={[sliderMin || 0, sliderMax || 0]}
                onChange={(values) => {
                  handlePriceChange({ min: values[0], max: values[1] });
                }}
              />
              <div className="d-flex justify-content-between mt-2">
                <span>₹ {sliderMin ?? 0}</span>
                <span>₹ {sliderMax ?? 0}</span>
              </div>
            </div>
          </div>
        )}


        {/* User Rating */}
        {/* <div className="filterpanelbody">
          <h3>User Rating</h3>
          <div className="filtercheckbody">
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="ratingExcellent" />
              <label className="form-check-label" htmlFor="ratingExcellent">
                Excellent: 4.2+
              </label>
            </div>
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="ratingVeryGood" />
              <label className="form-check-label" htmlFor="ratingVeryGood">
                Very Good: 3.5+
              </label>
            </div>
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="ratingGood" />
              <label className="form-check-label" htmlFor="ratingGood">
                Good: 3+
              </label>
            </div>
          </div>
        </div> */}

        {/* House Rules */}
        {/* <div className="filterpanelbody">
          <h3>House Rules</h3>
          <div className="filtercheckbody">
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="smokingAllowed" />
              <label className="form-check-label" htmlFor="smokingAllowed">
                Smoking Allowed
              </label>
            </div>
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="unmarriedCouplesAllowed" />
              <label className="form-check-label" htmlFor="unmarriedCouplesAllowed">
                Unmarried Couples Allowed
              </label>
            </div>
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="petsAllowed" />
              <label className="form-check-label" htmlFor="petsAllowed">
                Pets Allowed
              </label>
            </div>
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="alcoholAllowed" />
              <label className="form-check-label" htmlFor="alcoholAllowed">
                Alcohol Allowed
              </label>
            </div>
          </div>
        </div> */}

        {/* Room Views */}
        {/* <div className="filterpanelbody">
          <h3>Room Views</h3>
          <div className="filtercheckbody">
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="valleyView" />
              <label className="form-check-label" htmlFor="valleyView">
                Valley View
              </label>
            </div>
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="forestView" />
              <label className="form-check-label" htmlFor="forestView">
                Forest View
              </label>
            </div>
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="gardenView" />
              <label className="form-check-label" htmlFor="gardenView">
                Garden View
              </label>
            </div>
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="mountainView" />
              <label className="form-check-label" htmlFor="mountainView">
                Mountain View
              </label>
            </div>
          </div>
        </div> */}

        {/* Top locations */}
        {/* <div className="filterpanelbody">
  <h3>Top locations</h3>
  <div className="filtercheckbody">
    {locations.length > 0 ? (
      locations.map((loc) => (
        <div className="form-check" key={loc.id}>
          <input
            className="form-check-input"
            type="radio"   //. use radio instead of checkbox
            name="destination" //. all radios share same name
            id={`location-${loc.id}`}
            checked={selectedFilters.destination_id === loc.id}
            onChange={() => handleLocationChange(loc.id)}
          />
          <label
            className="form-check-label"
            htmlFor={`location-${loc.id}`}
          >
            {loc.location_name}
          </label>
        </div>
      ))
    ) : (
      <p>Loading locations...</p>
    )}
  </div>
</div> */}

        {/* Amenities */}
        {/* <div className="filterpanelbody">
          <h3>Amenities</h3>
          <div className="filtercheckbody">
            {amenities.length > 0 ? (
              amenities.map((amenity) => (
                <div className="form-check" key={amenity.id}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={`amenity-${amenity.id}`}
                    checked={selectedFilters.amenities.includes(amenity.id)}
                    onChange={() => handleAmenityChange(amenity.id)}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`amenity-${amenity.id}`}
                  >
                    {amenity.name}
                  </label>
                </div>
              ))
            ) : (
              <p>Loading amenities...</p>
            )}
          </div>
        </div> */}
        <div className="filterpanelbody">
          <h3>Amenities</h3>
          <div className="filtercheckbody">
            {amenities.length > 0 ? (
              amenities.map((amenity) => (
                <div className="form-check" key={amenity.id}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={`amenity-${amenity.id}`}
                    checked={selectedFilters.amenities.includes(amenity.id)}
                    onChange={() => handleAmenityChange(amenity.id)}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`amenity-${amenity.id}`}
                  >
                    {amenity.name}
                  </label>
                </div>
              ))
            ) : (
              <p>Loading amenities...</p>
            )}
          </div>
        </div>

        {/* Property Type — client-side refinement only, does not re-query the backend */}
        <div className="filterpanelbody">
          <h3>Property Type</h3>
          <div className="filtercheckbody">
            {PROPERTY_TYPES.map((type) => (
              <div className="form-check" key={type.value}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={`property-type-${type.value}`}
                  checked={selectedPropertyTypes.includes(type.value)}
                  onChange={() => handlePropertyTypeChange(type.value)}
                />
                <label
                  className="form-check-label"
                  htmlFor={`property-type-${type.value}`}
                >
                  {type.label}
                </label>
              </div>
            ))}
          </div>
        </div>

        {/* Offers */}
        {promoCodes.length > 0 && (
          <div className="filterpanelbody">
            <h3>Offers</h3>
            <div className="filtercheckbody">
              {promoCodes.map((promo) => (
                <div className="form-check" key={promo.code}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={`promo-${promo.code}`}
                    checked={selectedFilters.promo_codes.includes(promo.code)}
                    onChange={() => handlePromoCodeChange(promo.code)}
                  />
                  <label className="form-check-label" htmlFor={`promo-${promo.code}`}>
                    {promo.code} — {promo.title}
                  </label>
                </div>
              ))}
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default FilterSidebar;
